<template>
  <h1>{{ display }}</h1>
</template>
<script>
export default {
  name: 'DisplayResult',
  props: {
    result: {
      type: [Number, String],
      default: ''
    }
  },
  computed: {
    display() {
      return this.result
    }
  }
}
</script>
